import component from './component'

export default {
    path: '/graduados',
    name: 'graduados',
    component: component
}



// WEBPACK FOOTER //
// ./src/components/graduados/graduados/index.js